<app-loader *ngIf="loaderIcon | async"></app-loader>
<div class="layout-container">
    <app-operations [isCollapsed]="isCollapsed"></app-operations>
    <div class="main-content">
        <app-top-bar (toggleSidebar)="handleToggle()"></app-top-bar>
        <div class="content-area" [formGroup]="rentRenewalForm">
            <div class="d-flex justify-content-between align-items-center mb-3">
                <h5 class="fw-semibold">{{ tabHeaderTitle }}</h5>
            </div>
            <hr />
            <div class="row">
                <div class="col-12 text-start">
                    <ul class="nav nav-tabs custom-tabs">
                        <li class="nav-item">
                            <a class="nav-link active" data-bs-toggle="tab" href="#arr"
                                (click)="onTabChange('ARR')">Automatic Rent Renewal</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" data-bs-toggle="tab" href="#void" (click)="onTabChange('Void')">Void</a>
                        </li>
                    </ul>

                    <div class="tab-content">
                        <div class="tab-pane fade show active" id="arr">
                            <div class="p-3">
                                <div class="mb-3">
                                    <label class="form-label fw-semibold">Rental Type</label><br />
                                    <div class="form-check form-check-inline">
                                        <input class="form-check-input" type="radio" id="monthlyRent"
                                            formControlName="rentalType" value="monthly" />
                                        <label class="form-check-label" for="monthlyRent">Monthly Rent
                                            Renewal</label>
                                    </div>
                                    <div class="form-check form-check-inline" *ngIf="showCombinedWeekly">
                                        <input class="form-check-input" type="radio" id="weeklyRent"
                                            formControlName="rentalType" value="weekly" />
                                        <label class="form-check-label" for="weeklyRent">Combined Weekly Rent
                                            Renewal</label>
                                    </div>
                                </div>

                                <hr />

                                <div class="row mb-3">
                                    <div class="col-md-6 col-lg-3">
                                        <label for="renewalDate" class="form-label">Date of Renewal</label>
                                        <ejs-datepicker class="form-control p-0" formControlName="renewalDate"
                                            [min]="minExpiryDate"></ejs-datepicker>
                                    </div>

                                    <div class="col-md-6 col-lg-3"
                                        *ngIf="rentRenewalForm.get('rentalType')?.value === 'monthly'">
                                        <label for="startMonth" class="form-label">Start Month</label>
                                        <select class="form-select" id="startMonth" formControlName="startMonth"
                                            (change)="onStartMonthChange()">
                                            <option *ngFor="let month of monthOptions" [value]="month.label">
                                                {{ month.label }}
                                            </option>
                                        </select>
                                    </div>

                                    <div class="col-md-6 col-lg-3"
                                        *ngIf="rentRenewalForm.get('rentalType')?.value === 'monthly'">
                                        <label for="numMonths" class="form-label">Number of Months</label>
                                        <select class="form-select" id="numMonths" formControlName="numMonths">
                                            <option *ngFor="let n of numberOfMonths" [ngValue]="n">{{ n }}</option>
                                        </select>
                                    </div>

                                    <div class="col-md-6 col-lg-3"
                                        *ngIf="rentRenewalForm.get('rentalType')?.value === 'weekly'">
                                        <label for="startWeek" class="form-label">Start Week</label>
                                        <select class="form-select" id="startWeek" formControlName="startWeek"
                                            (change)="onStartWeekChange()">
                                            <option *ngFor="let week of weekOptions" [value]="week.label">
                                                {{ week.label }}
                                            </option>
                                        </select>
                                    </div>

                                    <div class="col-md-6 col-lg-3"
                                        *ngIf="rentRenewalForm.get('rentalType')?.value === 'weekly'">
                                        <label for="numWeeks" class="form-label">Number of Weeks</label>
                                        <select class="form-select" id="numWeeks" formControlName="numWeeks">
                                            <option *ngFor="let n of numberOfWeeks" [ngValue]="n">
                                                {{ n }}
                                            </option>
                                        </select>
                                    </div>

                                </div>

                                <hr />

                                <div class="mb-3">
                                    <label class="form-label fw-semibold">Treat Rental Charges as</label><br />
                                    <div class="form-check form-check-inline mt-1">
                                        <input class="form-check-input" type="radio" id="paid"
                                            formControlName="treatRentalChargesAs" [value]="1" />
                                        <label class="form-check-label" for="paid">Paid</label>
                                    </div>
                                    <div class="form-check form-check-inline mt-1">
                                        <input class="form-check-input" type="radio" id="balanceDue"
                                            formControlName="treatRentalChargesAs" [value]="0" />
                                        <label class="form-check-label" for="balanceDue">Balance Due</label>
                                    </div>
                                </div>
                                <hr />

                                <div class="form-check mb-2">
                                    <input class="form-check-input" type="checkbox" id="recurringCharges"
                                        formControlName="recurringCharges" />
                                    <label class="form-check-label" for="recurringCharges">
                                        Renew Recurring Other Charges
                                    </label>
                                </div>

                                <div class="form-check mb-2">
                                    <input class="form-check-input" type="checkbox" id="excludeDealers"
                                        formControlName="excludeDealers" />
                                    <label class="form-check-label" for="excludeDealers">
                                        Exclude Dealers Flagged As Exclude From Automatic Rent Renewal
                                    </label>
                                </div>

                                <div class="form-check mb-2">
                                    <input class="form-check-input" type="checkbox" id="printReceipt"
                                        formControlName="printReceipt" />
                                    <label class="form-check-label" for="printReceipt">
                                        Print Rent Renewal Receipt on Completion of Automatic Renewal
                                    </label>
                                </div>

                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" id="emailReceipt"
                                        formControlName="emailReceipt" />
                                    <label class="form-check-label" for="emailReceipt">
                                        E-mail Rental Renewal Receipt
                                    </label>
                                </div>

                                <hr />

                                <div class="row">
                                    <div class="text-start">
                                        <label>Rental Notes</label><br />
                                        <textarea class="form-control" formControlName="rentalNotes"></textarea>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="tab-pane fade" id="void">
                            <div class="p-3">
                                <label class="form-label fw-semibold">Receipt Range</label>
                                <div class="row">
                                    <div class="col-md-6 col-lg-3 text-left mt-2">
                                        <label>From Receipt ID</label>
                                        <input type="number" class="form-control" formControlName="voidFromReceiptId" />
                                    </div>
                                    <div class="col-md-6 col-lg-3 text-left mt-2">
                                        <label>To Receipt ID</label>
                                        <input type="number" class="form-control" formControlName="voidToReceiptId" />
                                    </div>
                                </div>
                                <hr />
                                <div class="row">
                                    <div class="col-12 text-left mt-2">
                                        <label>Reason For Void</label>
                                        <textarea class="form-control" formControlName="reasonForVoid"
                                            maxlength="10"></textarea>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row pe-3">
                            <div class="col-12 text-end my-2">
                                <button type="button" class="btn btnAS me-1" (click)="onPrimaryAction()">
                                    {{ activeTab === 'VOID' ? 'Proceed with Void ARR' : 'Proceed with Renewal' }}
                                </button>
                                <button type="button" class="btn btn-orange" (click)="closeARRPage()">Close</button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Display Receipts Preview Modal -->
<div class="modal fade" id="previewAttachmentModal" tabindex="-1" aria-labelledby="previewAttachmentModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-xl modal-fullSize">
        <div class="modal-content">
            <div class="modal-header d-flex justify-content-between align-items-center">
                <h5 class="modal-title mb-0" id="previewAttachmentModalLabel">
                    Rental Receipts
                </h5>
            </div>
            <!-- BODY -->
            <div class="modal-body p-0">
                <div *ngIf="loading" class="d-flex justify-content-center align-items-center" style="height:300px;">
                    <div class="spinner-border text-primary"></div>
                </div>
                <!-- PDF iframe -->
                <iframe id="previewprintf" *ngIf="!loading" width="100%" height="500px" frameborder="0">
                </iframe>
            </div>
            <div class="modal-footer justify-content-end">
                <button class="btn btn-orange" (click)="closeModalById('previewAttachmentModal')">
                    Close
                </button>
            </div>
        </div>
    </div>
</div>